// extracted by mini-css-extract-plugin
export default {"PasswordResetPhone":"yq_a bhf_qr bhf_a bhf_w bhf_ea bhf_tj"};